export default __webpack_public_path__ + "static/media/image.sc-one-world-private-limited.0f5421ac.png";